export interface DataSets {
  label: string;
  labelEn?: string;
  timeUnit?: string;
  labelEnUnit?: string;
  isAlwaysShow?: boolean; // default = true
  isDefault: boolean;
  isChecked: boolean;
  isReadonly: boolean;
  isFetchable: boolean;
  isFetchChecked: boolean;
  pay_tax?: CheckboxValues;
  transfer_to_account?: CheckboxValues;
  base_salary_adjustment?: CheckboxValues;
  radioItems?: RadioItem[];
  onChange?: any;
  pendingRequest?: any;
  approveRequest?: any;
  customReadOnly?: any;
}

export interface CheckboxValues {
  isDefault: boolean;
  isChecked: boolean;
  isReadonly: boolean;
  isShow: boolean;
}

export const AddHocCheckbox = {
  isDefault: false,
  isChecked: false,
  isReadonly: false,
  isShow: true,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: true,
  },
};

export interface RadioItem {
  label: string;
  value: any;
  checked?: boolean;
}

export const RadioTimeItem: RadioItem[] = [{
  label: 'ชั่วโมง',
  value: 'hourly',
  checked: true
}, {
  label: 'วัน',
  value: 'daily',
  checked: false
}];

const onIncomeValueChanged = (instance, cell, x, y, value) => {
};

export const ExtraIncomeNoti = ['commission', 'holiday', 'otHoliday', 'ot', 'phoneBill', 'oilCost', 'travelExpense', 'reservedPayment'];
export const ExtraIncomeNotiHourly = ['holiday_hourly', 'otHoliday_hourly', 'ot_hourly'];
export const ExtraIncomeNotiHourlyTypes = ['holiday', 'ot_holiday', 'ot'];

export const INCOMELIST: DataSets[] = [{
  label: 'เงินเดือน',
  labelEn: 'salary',
  isDefault: false,
  isChecked: true,
  isReadonly: true,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าจ้าง (ลูกจ้างรายวัน)',
  labelEn: 'wage',
  timeUnit: 'daily',
  isAlwaysShow: false,
  isDefault: false,
  isChecked: true,
  isReadonly: true,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'โบนัส',
  labelEn: 'bonus',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าคอมมิชชั่น',
  labelEn: 'commission',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'เบี้ยเลี้ยง',
  labelEn: 'allowance',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: true,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: true,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'เงินประจำตำแหน่ง',
  labelEn: 'professionalFee',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าทำงานวันหยุด',
  labelEn: 'holiday',
  timeUnit: 'hourly',
  labelEnUnit: 'holiday_hourly',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  // radioItems: RadioTimeItem
  onChange: onIncomeValueChanged
}, {
  label: 'OT ค่าล่วงเวลา',
  labelEn: 'ot',
  timeUnit: 'hourly',
  labelEnUnit: 'ot_hourly',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  // radioItems: RadioTimeItem
  onChange: onIncomeValueChanged
}, {
  label: 'OT ค่าล่วงเวลาวันหยุด',
  labelEn: 'otHoliday',
  timeUnit: 'hourly',
  labelEnUnit: 'otHoliday_hourly',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  // radioItems: RadioTimeItem
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าโทรศัพท์',
  labelEn: 'phoneBill',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: true,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: true,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าน้ำมัน',
  labelEn: 'oilCost',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: true,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: true,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ค่าเดินทาง',
  labelEn: 'travelExpense',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: true,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: true,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ประโยชน์จากการได้ที่พักฟรี',
  labelEn: 'freeAccommodation',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'ภาษีที่นายจ้างออกให้',
  labelEn: 'taxEmployer',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: true,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}, {
  label: 'เงินสำรองจ่าย',
  labelEn: 'reservedPayment',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  pay_tax: {
    isDefault: true,
    isChecked: false,
    isReadonly: true,
    isShow: true,
  },
  transfer_to_account: {
    isDefault: true,
    isChecked: true,
    isReadonly: false,
    isShow: true,
  },
  base_salary_adjustment: {
    isDefault: false,
    isChecked: false,
    isReadonly: false,
    isShow: false,
  },
  onChange: onIncomeValueChanged
}];

export const ENDDATEINCOMELIST: DataSets[] = [
  {
    label: 'ค่าชดเชย (เสียภาษี)',
    labelEn: 'severanceTaxable',
    isDefault: false,
    isChecked: true,
    isReadonly: true,
    isFetchable: false,
    isFetchChecked: false,
    pay_tax: {
      isDefault: true,
      isChecked: true,
      isReadonly: true,
      isShow: true,
    },
    transfer_to_account: {
      isDefault: true,
      isChecked: true,
      isReadonly: false,
      isShow: true,
    },
    base_salary_adjustment: {
      isDefault: false,
      isChecked: false,
      isReadonly: false,
      isShow: false,
    },
    onChange: onIncomeValueChanged
  },
  {
    label: 'ค่าชดเชย (ไม่เสียภาษี)',
    labelEn: 'severanceTaxExempt',
    isDefault: false,
    isChecked: true,
    isReadonly: true,
    isFetchable: false,
    isFetchChecked: false,
    pay_tax: {
      isDefault: true,
      isChecked: true,
      isReadonly: true,
      isShow: true,
    },
    transfer_to_account: {
      isDefault: true,
      isChecked: true,
      isReadonly: false,
      isShow: true,
    },
    base_salary_adjustment: {
      isDefault: false,
      isChecked: false,
      isReadonly: false,
      isShow: false,
    },
    onChange: onIncomeValueChanged
  },
  {
    label: 'สินจ้างแทนการบอกกล่าวล่วงหน้า',
    labelEn: 'advanceNotice',
    isDefault: false,
    isChecked: true,
    isReadonly: true,
    isFetchable: false,
    isFetchChecked: false,
    pay_tax: {
      isDefault: true,
      isChecked: true,
      isReadonly: true,
      isShow: true,
    },
    transfer_to_account: {
      isDefault: true,
      isChecked: true,
      isReadonly: false,
      isShow: true,
    },
    base_salary_adjustment: {
      isDefault: false,
      isChecked: false,
      isReadonly: false,
      isShow: false,
    },
    onChange: onIncomeValueChanged
  },
  // {
  //   label: 'เงินบำเหน็จฯ ข้าราชการ',
  //   labelEn: 'governmentLastPayment',
  //   isDefault: false,
  //   isChecked: true,
  //   isReadonly: true,
  //   isFetchable: false,
  //   isFetchChecked: false,
  //   pay_tax: {
  //     isDefault: true,
  //     isChecked: true,
  //     isReadonly: true,
  //     isShow: true,
  //   },
  //   transfer_to_account: {
  //     isDefault: true,
  //     isChecked: true,
  //     isReadonly: false,
  //     isShow: true,
  //   },
  //   base_salary_adjustment: {
  //     isDefault: false,
  //     isChecked: false,
  //     isReadonly: false,
  //     isShow: false,
  //   },
  //   onChange: onIncomeValueChanged
  // },
  // {
  //   label: 'เงินเกษียณก่อนกำหนด (Early retire)',
  //   labelEn: 'earlyRetire',
  //   isDefault: false,
  //   isChecked: true,
  //   isReadonly: true,
  //   isFetchable: false,
  //   isFetchChecked: false,
  //   pay_tax: {
  //     isDefault: true,
  //     isChecked: true,
  //     isReadonly: true,
  //     isShow: true,
  //   },
  //   transfer_to_account: {
  //     isDefault: true,
  //     isChecked: true,
  //     isReadonly: false,
  //     isShow: true,
  //   },
  //   base_salary_adjustment: {
  //     isDefault: false,
  //     isChecked: false,
  //     isReadonly: false,
  //     isShow: false,
  //   },
  //   onChange: onIncomeValueChanged
  // },
  {
    label: 'ค่าจ้างแทนวันพักร้อนที่ไม่ได้ใช้',
    labelEn: 'holidayLeave',
    isDefault: false,
    isChecked: true,
    isReadonly: true,
    isFetchable: false,
    isFetchChecked: false,
    pay_tax: {
      isDefault: true,
      isChecked: true,
      isReadonly: true,
      isShow: true,
    },
    transfer_to_account: {
      isDefault: true,
      isChecked: true,
      isReadonly: false,
      isShow: true,
    },
    base_salary_adjustment: {
      isDefault: false,
      isChecked: false,
      isReadonly: false,
      isShow: false,
    },
    onChange: onIncomeValueChanged
  },
  {
    label: 'เงินก้อนสุดท้าย',
    labelEn: 'compensation',
    isDefault: false,
    isChecked: true,
    isReadonly: true,
    isFetchable: false,
    isFetchChecked: false,
    pay_tax: {
      isDefault: true,
      isChecked: true,
      isReadonly: true,
      isShow: true,
    },
    transfer_to_account: {
      isDefault: true,
      isChecked: true,
      isReadonly: false,
      isShow: true,
    },
    base_salary_adjustment: {
      isDefault: false,
      isChecked: false,
      isReadonly: false,
      isShow: false,
    },
    onChange: onIncomeValueChanged
  },
];

export const EXPENSELIST: DataSets[] = [{
  label: 'ประกันสังคม',
  labelEn: 'socialSecurity',
  isDefault: true,
  isChecked: false,
  isReadonly: true,
  isFetchable: false,
  isFetchChecked: false,
}, {
  label: 'กองทุนสำรองเลี้ยงชีพ',
  labelEn: 'providentFund',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
}, {
  label: 'กยศ.',
  labelEn: 'studentLoan',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
}, {
  label: 'มาสาย',
  labelEn: 'late',
  timeUnit: 'hourly',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  // radioItems: RadioTimeItem
}, {
  label: 'ลา / ขาดงาน / Leave without pay',
  labelEn: 'absent',
  timeUnit: 'hourly',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
  // radioItems: RadioTimeItem
}, {
  label: 'หักเงินเดือน',
  labelEn: 'payCut',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: false,
  isFetchChecked: false,
}, {
  label: 'เงินประกันการทำงาน',
  labelEn: 'workInsurance',
  isDefault: true,
  isChecked: false,
  isReadonly: false,
  isFetchable: true,
  isFetchChecked: false,
}, {
  label: 'ภาษีหัก ณ ที่จ่าย',
  labelEn: 'withholdingTax',
  isDefault: true,
  isChecked: false,
  isReadonly: true,
  isFetchable: false,
  isFetchChecked: false,
}];

export const ENDDATEEXPENSELIST: DataSets[] = [{
  label: 'ภาษีหัก ณ ที่จ่าย (ออกจากงาน)',
  labelEn: 'withholdingTaxQuit',
  isDefault: false,
  isChecked: true,
  isReadonly: true,
  isFetchable: false,
  isFetchChecked: false,
}];

export const autoCalColumnList = ['socialSecurity', 'providentFund', 'providentFundEmployer', 'studentLoan', 'withholdingTax'];
export const pvdStlColumn = ['providentFund', 'studentLoan'];
export const autoCalPvdExpenseColumn = ['payCut', 'late', 'absent'];

export const restrictedColumnNameList = ['phoneAllowance'];

export enum RecalType {
  withholdingTax = 'wht',
  socialSecurity = 'sso',
  providentFund = 'pvd',
  studentLoan = 'slf',
  providentFundPercentage = 'pvd_percentage',
  providentFundEmployer = 'pvd_employer',
}
